import { NgModule } from '@angular/core';
import { ComponentModule } from '../component/component.module';
import { TranslateModule } from '@ngx-translate/core';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { CoreModule } from '../core/core.module';
import { HomeComponent } from './home/home.component';
import { BottomPanelModule } from '../bottom-panel/bottom-panel.module';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { PageRoutingModule } from './page-routing.module';
import { EditInfoModule } from './edit-info-routing/edit-info.module';
import {ErrorComponent} from './error/error.component';

export const COMPONENTS = [HomeComponent,ErrorComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [
    SimpleNotificationsModule,
    TranslateModule,
    CommonModule,
    ComponentModule,
    CoreModule,
    SharedModule,
    BottomPanelModule,
    PageRoutingModule,
    EditInfoModule,
  ],
  exports: COMPONENTS,
})
export class PageModule {}
